import i18next from 'i18next';

import { DELIVERY_TYPES } from '~constants/delivery';

i18next.addResources('es_CL', 'DeliveryActionsModal', {
  confirm: 'confirmar',
  return: 'volver',
  title: 'Cambiar delivery',
  orderNum: 'Pedido #{{id}}',
  currentDelivery: 'Delivery actual:',
  paymentMethod: 'Medio de pago:',
  paidAmount: 'Monto pagado por cliente:',
  [DELIVERY_TYPES.OWN]: 'Delivery propio',
  [DELIVERY_TYPES.UBER]: 'Uber Direct',
  [DELIVERY_TYPES.PEYA]: 'PedidosYa',
  [DELIVERY_TYPES.CABIFY]: 'Cabify',
  [DELIVERY_TYPES.PEYA_V3]: 'Pedidos Ya V3',
  [DELIVERY_TYPES.RAPPI_CARGO]: 'Rappi Cargo',
  sameFee: 'Misma tarifa',
  pro: 'a favor',
  counter: 'en contra',
  deliveryIn: 'Entrega en {{minutesToDropoff}} mins.',
  requote: 'Recotizar',
  cancelOrder: 'Anular pedido',
  cancelDeliverytitle: 'Delivery cancelado',
  orderId: '#{{id}}',
  deliveryItems: 'Resumen del pedido',
  client: 'Cliente:',
  deliveryTo: 'Delivery a: {{address}}',
  noDelivery: 'Sin delivery',
  noDeliveryTitle: 'Asignar delivery',
  by: 'por',
  assignNewDelivery: 'Asigna un nuevo delivery:',
  omit: 'omitir'
});

i18next.addResources('es_CR', 'DeliveryActionsModal', {
  confirm: 'confirmar',
  return: 'volver',
  title: 'Cambiar delivery',
  orderNum: 'Pedido #{{id}}',
  currentDelivery: 'Delivery actual:',
  paymentMethod: 'Medio de pago:',
  paidAmount: 'Monto pagado por cliente:',
  [DELIVERY_TYPES.OWN]: 'Delivery propio',
  [DELIVERY_TYPES.UBER]: 'Uber Direct',
  [DELIVERY_TYPES.PEYA]: 'PedidosYa',
  [DELIVERY_TYPES.CABIFY]: 'Cabify',
  [DELIVERY_TYPES.PEYA_V3]: 'Pedidos Ya V3',
  [DELIVERY_TYPES.RAPPI_CARGO]: 'Rappi Cargo',
  sameFee: 'Misma tarifa',
  pro: 'a favor',
  counter: 'en contra',
  deliveryIn: 'Entrega en {{minutesToDropoff}} mins.',
  requote: 'Recotizar',
  cancelOrder: 'Anular pedido',
  cancelDeliverytitle: 'Delivery cancelado',
  orderId: '#{{id}}',
  deliveryItems: 'Resumen del pedido',
  client: 'Cliente:',
  deliveryTo: 'Delivery a: {{address}}',
  noDelivery: 'Sin delivery',
  noDeliveryTitle: 'Asignar delivery',
  by: 'por',
  assignNewDelivery: 'Asigna un nuevo delivery:',
  omit: 'omitir'
});
